import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'app/hooks';
import {
  joinWatchTimeshare,
  selectInTimeshare,
} from 'features/spectrasWebSocketServer/spectrasWebSocketServerSlice';

interface Props {
  userId: number;
  analyzerId: number;
}

export const useWatchTimeshareChannel = ({ userId, analyzerId }: Props) => {
  const dispatch = useAppDispatch();
  const inTimeshare = useAppSelector(selectInTimeshare);

  useEffect(() => {
    if (inTimeshare) return;

    dispatch(
      joinWatchTimeshare({
        user_id: userId,
        analyzer_id: analyzerId,
      })
    );
  }, [dispatch, inTimeshare, userId, analyzerId]);
};
